export enum AnnouncementSort {
    Title = 1,
    Text = 2,
    DateFrom = 3,
    IsSticky = 4,
    ApplicationDisplay = 5,
    Status = 6
}